module.exports = __webpack_public_path__ + "static/media/setting.2422efc7.jpg";